import API from "./index";

class ApoliceSeguroIBPService {
  constructor() {
    this.path = `api/apolice-seguro-ibp`;
  }


  findById(id) {
    return API.get(`${this.path}/findById/${id}`);

  }

  deletar(id) {
    return API.delete(`${this.path}/deletar/${id}`);
  }

  

  salvar(entity) {
    return API.post(`${this.path}/salvar`, entity, {

    });

  }

  editar(entity) {
    return API.put(`${this.path}/editar`, entity, {

    });

  }


}

export default ApoliceSeguroIBPService;
